module.exports = __webpack_public_path__ + "static/media/brands_milan.82009ea0.png";